function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("circle", {
  cx: "20",
  cy: "20.5",
  r: "20",
  fill: "#92BBF7"
}), React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "40",
  height: "41"
}, React.createElement("circle", {
  cx: "20",
  cy: "20.5",
  r: "20",
  fill: "#92BBF7"
})), React.createElement("g", {
  mask: "url(#a)"
}, React.createElement("path", {
  d: "M6 13.5a3 3 0 013-3h22a3 3 0 013 3v27a3 3 0 01-3 3H9a3 3 0 01-3-3v-27z",
  fill: "#596DCF"
})), React.createElement("rect", {
  x: "11",
  y: "16.5",
  width: "18",
  height: "3",
  rx: "1.5",
  fill: "#FFFDFD"
}), React.createElement("rect", {
  x: "11",
  y: "22.5",
  width: "18",
  height: "3",
  rx: "1.5",
  fill: "#FFFDFD"
}), React.createElement("rect", {
  x: "18",
  y: "28.5",
  width: "11",
  height: "3",
  rx: "1.5",
  fill: "#FFFDFD"
})));